<i18n>
{
	"en": {
		"InputInfoToSearch": "Input info to search..."
	},
	"vi": {
		"InputInfoToSearch": "Nhập thông tin để tìm kiếm..."
	}
}
</i18n>

<template>
	<div class="cbs-relation-control">
		<legend class="flex justify-between items-center">
			<div>
				{{ localValue.title }}<span class="text-danger" v-if="!localValue.is_optional">&nbsp;*</span>:
			</div>
			<cbs-hint
				v-if="
					localValue.description &&
					localValue.description.enable &&
					localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.ICON
				"
				:data="localValue.description && localValue.description.value"
			/>
		</legend>

		<div
			class="my-1"
			v-if="
				localValue.description &&
				localValue.description.enable &&
				localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP
			"
		>{{ localValue.description && localValue.description.value }}</div>
		<v-select
			v-if="localIsMultitpleAttributeValue"
			multiple
			label="content"
			v-bind="$attrs"
			v-model="localValue.value"
			class="select-multiple w-full"
			v-validate="!localValue.is_optional ? 'required' : ''"
			:filterable="false"
			:close-on-select="false"
			:options="relationOptions"
			:data-vv-as="localValue.title"
			:key="`${localValue.title}-${localValue.id}`"
			:name="`${localValue.title}-${localValue.id}`"
			:placeholder="`${$t('Actions.Choose')} ${localValue.title.toLowerCase()}`"
			@search="autoCompleteSelectRelation"
		>
			<span slot="no-options">{{ $t(`${!isSearching && searchText ? 'Notify.NoMatchingOptions' : 'InputInfoToSearch'}`) }}</span>
		</v-select>
		<v-select
			v-else
			class="w-full"
			label="content"
			v-bind="$attrs"
			v-model="localValue.value[0]"
			v-validate="!localValue.is_optional ? 'required' : ''"
			:filterable="false"
			:options="relationOptions"
			:data-vv-as="localValue.title"
			:key="`${localValue.title}-${localValue.id}`"
			:name="`${localValue.title}-${localValue.id}`"
			:placeholder="`${$t('Actions.Choose')} ${localValue.title.toLowerCase()}`"
			@search="autoCompleteSelectRelation"
			@input="changeRoute"
		>
			<span slot="no-options">{{ $t(`${!isSearching && searchText ? 'Notify.NoMatchingOptions' : 'InputInfoToSearch'}`) }}</span>
		</v-select>
		<span
			class="text-danger text-sm"
			v-if="!localValue.is_optional"
		>{{ errors.first(`${localValue.title}-${localValue.id}`) }}</span>
		<div
			class="my-1"
			v-if="
				localValue.description &&
				localValue.description.enable &&
				localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM
			"
		>{{ localValue.description && localValue.description.value }}</div>
	</div>
</template>

<script>
import requestV2GQL from "@/http/requests/request/request_v2_gql.js";

import vSelect from "vue-select";
import CbsHint from "@/components/cbs-hint/CbsHint.vue";

export default {
	inheritAttrs: false,
	name: "RelationControl",
	inject: ["parentValidator"],
	components: {
		CbsHint,
		vSelect
	},
    props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("children") &&
				prop.hasOwnProperty("attributes") &&
				prop.hasOwnProperty("is_optional") &&
				prop.hasOwnProperty("description")
		},
		indexValue: {
			type: Number,
		}
	},
	data() {
		return {
			searchText: null,
			isSearching: false,
			relationOptions: []
		};
	},
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
		},
		localAttributesValue() {
			const attributesValue = typeof this.localValue.attributes === "string" ? JSON.parse(this.localValue.attributes) : this.localValue.attributes;
			return attributesValue;
		},
		localIsMultitpleAttributeValue() {
			return !!this.localAttributesValue.is_multiple;
		},
		localRelatedModelAttributeValue() {
			return this.localAttributesValue.related_model || "";
		}
	},
	methods: {
		changeRoute() {
			this.$emit("onReInitAutofillData", {indexValue: this.indexValue, current_value: this.localValue});
		},
		autoCompleteSelectRelation(text, loading) {
			clearTimeout(this.timer);
			this.timer = setTimeout(async () => {
				try {
                    if (loading) {
                        loading(true);
					}
					this.isSearching = true;
					this.searchText = text || "";
					const model = this.localRelatedModelAttributeValue;
					const response = await requestV2GQL.getRelationByModel({
						model,
						page: 1,
						limit: 100,
						name: this.searchText
					});
					this.relationOptions = response;
				} catch (error) {
                    this.$helper.notifyError({
                        error,
                        context: this
                    });
				} finally {
                    if (loading) {
                        loading(false);
					}
					this.isSearching = false;
                }
			}, 300);
        }
	},
	created() {
        if (this.parentValidator) {
            this.$validator = this.parentValidator;
		}
	}
}
</script>

<style>

</style>